import Link from 'next/link'
import { forwardRef } from 'react'
import { Button as CCUIButton } from '@captaincause/ui/Button'
import type { ButtonProps as CCUIButtonProps } from '@captaincause/ui/Button'
import type { LinkProps } from 'next/link'

export type ButtonProps = Omit<CCUIButtonProps, 'Link'> &
  Omit<LinkProps, 'href'>

function ButtonWithRef(props: ButtonProps, ref: any) {
  return <CCUIButton {...props} Link={Link} ref={ref} isNextLink />
}

export const Button = forwardRef(ButtonWithRef)
